import { app } from '../../../app';

app.factory('SmsUserActivationCodeGeneration', SmsUserActivationCodeGeneration);

/** @ngInject */
function SmsUserActivationCodeGeneration($resource) {
    return $resource('app/rest/smsUserActivationCodeGeneration', {}, {
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/sms-user-registration/sms-user-activation-code-generation.service.js